import { Phone, Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LocalizedLink } from "../lib/i18nRouting";
import SEO from "../components/site/SEO";
import Reveal from "../components/Reveal";

export default function Contact() {
  const { t } = useTranslation();
  return (
    <div className="bg-bone min-h-screen" data-testid="contact-page">
      <SEO titleKey="contact.title" descKey="contact.description" path="/contact" />
      <section className="pt-32 lg:pt-44 pb-24 lg:pb-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-12 gap-16">
          <Reveal className="md:col-span-7">
            <div className="text-xs uppercase tracking-wider-3 text-moss mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-moss" />
              {t("contact.eyebrow")}
            </div>
            <h1 className="font-display text-6xl md:text-7xl lg:text-8xl text-forest leading-[1.02]">
              {t("contact.title_a")}<br/><span className="italic">{t("contact.title_b")}</span>.
            </h1>
            <p className="mt-8 max-w-xl text-muted-foreground text-base md:text-lg leading-relaxed">{t("contact.intro")}</p>
          </Reveal>

          <div className="md:col-span-5">
            <Reveal className="border border-bone-deep bg-white p-8 lg:p-10 space-y-8">
              <Item icon={<Phone className="w-5 h-5" />} label={t("common.phone")} value="0752 354 222" href="tel:0752354222" testid="contact-phone" />
              <Item icon={<Mail className="w-5 h-5" />} label={t("common.email")} value="contact@apuseniactive.ro" href="mailto:contact@apuseniactive.ro" testid="contact-email" />
              <Item icon={<MapPin className="w-5 h-5" />} label={t("common.locations")} value="Oradea · Băile Felix · Băile 1 Mai" testid="contact-locations" />
              <LocalizedLink
                to="/rezervare"
                data-testid="contact-cta-book"
                className="btn-lift mt-6 inline-flex w-full items-center justify-center gap-2 bg-forest text-bone px-6 py-4 text-xs uppercase tracking-wider-3 hover:bg-forest-deep"
              >
                {t("contact.cta_book")}
              </LocalizedLink>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}

function Item({ icon, label, value, href, testid }) {
  const Inner = (
    <>
      <div className="text-forest opacity-80 mt-0.5">{icon}</div>
      <div>
        <div className="text-[10px] uppercase tracking-wider-3 text-moss">{label}</div>
        <div className="text-base text-forest mt-1.5">{value}</div>
      </div>
    </>
  );
  return href ? (
    <a href={href} data-testid={testid} className="flex items-start gap-4 group hover:text-terracotta transition-colors">{Inner}</a>
  ) : (
    <div data-testid={testid} className="flex items-start gap-4">{Inner}</div>
  );
}
